"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _goodsList = _interopRequireDefault(require("../../components/trade/goods-list.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _api = _interopRequireDefault(require("../../api/api"));
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'pubcarsucceed',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    goodsList: _goodsList.default,
    footNav: _footNav.default
  },
  data: function data() {
    return {
      // session替换成cookie
      userid: (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).userId : '',
      // userid: window.sessionStorage.getItem('user')?JSON.parse(window.sessionStorage.getItem('user')).userId:'',
      vsid: '',
      //车源id
      recData: [],
      rightAdverData: [],
      //右侧广告
      initQCode: 'http://www.weihuabiaoju.com/appDownload.dhtml?ncrypt=()(c)L33E/NY32aX1VkUU366w==',
      shareConfig: {
        url: this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=3&id=' + this.vsid + '&userId=' + this.userid,
        title: '有【车】找货',
        image: 'http://www.weihuabiaoju.com/mp/images/wximg/logo-center.jpg',
        sites: ['qq', 'wechat', 'weibo'],
        wechatQrcodeTitle: '微信扫一扫',
        wechatQrcodeHelper: '<p>请用微信扫码分享</p>'
      },
      sortConfig: {
        sortFlag: false
      },
      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }]
    };
  },
  created: function created() {
    this.vsid = this.$route.query.vsid;
    if (this.vsid) {
      this.loadRecData();
      this.shareConfig.url = this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=3&id=' + this.vsid + '&userId=' + this.userid;
    }
    this.loadAdvertiseData(); //右侧广告
  },
  mounted: function mounted() {
    this.$refs['tabs'].scrollIntoView({
      behavior: "smooth",
      // 平滑过渡
      block: "start" // start,center,end
    });
  },
  methods: {
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    },
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, userInfo, _yield$Api$apiGetAdve, success, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this; // session替换成cookie
              userInfo = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')) : ''; // var userInfo = JSON.parse(window.sessionStorage.getItem('user'))
              _context.next = 4;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_VS_RELEASE_SUCCESS',
                userId: userInfo ? userInfo.usid : ''
              });
            case 4:
              _yield$Api$apiGetAdve = _context.sent;
              success = _yield$Api$apiGetAdve.success;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData.filter(function (item) {
                return item.showPosition != 'CENTER';
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    //分享到微博
    toSinNo: function toSinNo() {
      var url = this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=1&id=' + this.detailData.ammId + '&userId=' + this.userid;
      var sharesinastring = 'http://v.t.sina.com.cn/share/share.php?title=' + this.detailData.articleTitle + '&url=' + url + '&content=utf-8&sourceUrl=' + url + '&pic=' + this.detailData.pictureOssUrls;
      window.open(sharesinastring, 'newwindow', 'height=400,width=400,top=100,left=100');
    },
    //获取相关推荐(货源)
    loadRecData: function () {
      var _loadRecData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, param, _yield$Api$apiGetRecG, success, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              param = {
                pageno: 1,
                pagesize: 4,
                vsid: that.vsid
              };
              _context2.next = 4;
              return _api.default.apiGetRecGoodsByvsidData(param);
            case 4:
              _yield$Api$apiGetRecG = _context2.sent;
              success = _yield$Api$apiGetRecG.success;
              data = _yield$Api$apiGetRecG.data;
              that.recData = data.proData;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadRecData() {
        return _loadRecData.apply(this, arguments);
      }
      return loadRecData;
    }()
  }
};